import { HostBinding, Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';

import { ModalService } from 'app/shared/modal/modal.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { FluxoVestibularService } from './shared/fluxoVestibular.service';
import { VestibularService } from '../shared/vestibular.service';

import { DadosVestibular } from 'models/dados-vestibular';
import { Vestibular } from 'models/vestibular';

import { environment } from '../../../environments/environment';


@Component({
  moduleId: module.id.toString(),
  templateUrl: './inscricao.component.html',
  styleUrls: ['./inscricao.component.scss'],
  animations: [routerTransition],
  providers: [FluxoVestibularService],
})
export class InscricaoComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  vestibular: any = {};
  dadosVestibular: DadosVestibular;
  resumoFluxo: any[] = [];
  loadingInicial = true;

  routerSubscription: Subscription;
  dadosVestibularSubscription: Subscription;
  resumoFluxoSubscription: Subscription;
  environment = environment;
  cursosDesconto50 = ['0001','0021','0075','0003','0006','0027','0049','0067','0089','0051','0091','0092','0077','0015','0013','0028'];
  cursosDesconto40 = ['0078','0074','0046','0019','0053','0020','0022','0050','0023','0043','0005'];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoVestibularService: FluxoVestibularService,
    private vestibularService: VestibularService,
    private modalService: ModalService,
    private notificationsService: NotificationsService,
    private cdr: ChangeDetectorRef,
  ) {
    this.routerSubscription = this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((evento) => {

        if (evento instanceof NavigationEnd) {
          const routePattern = /(\/vestibular\/inscricao)\/\d{4}\/\d\/(.*)/i;
          const path = evento.url.match(routePattern);

          if (!this.dadosVestibular || !path || path.length <= 2) {
            return;
          }
          const currentRoute = path[2];
          if (!this.fluxoVestibularService.validarRotaAtual(currentRoute) &&
              !this.fluxoVestibularService.passoAtualRetornavel()) {
            this.notificationsService.error('Ação não permitida!',
              'Para completar a inscrição você precisa passar por cada etapa na ordem estabelecida.');
            const proximaRota = this.fluxoVestibularService.proximaRota();
            this.router.navigate([proximaRota], { relativeTo: this.route });
          } else {
            this.fluxoVestibularService.atualizarPassoPorRota(currentRoute);
          }
        }
      });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const ano: string = params['ano'];
      const codigo: number = parseInt(params['id'], 10);

      this.vestibularService.getVestibularById(ano, codigo).then((vestibular: Vestibular) => {
        // vestibular nao existe ou ja fechou inscricao
        if (!vestibular || !this.vestibularService.isInscricaoAberta(vestibular)) {
          this.router.navigate(['/vestibular']);
          return;
        }

        this.vestibular = vestibular;
        this.fluxoVestibularService.setDadosVestibular({ vestibular });

        this.initSubscriptions();
        this.loadingInicial = false;

        const proximaRota = this.fluxoVestibularService.proximaRota();
        this.router.navigate([proximaRota],
          {
            relativeTo: this.route,
            queryParamsHandling: 'preserve',
          });
      });
    });
  }


  initSubscriptions() {
    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    this.resumoFluxo = this.fluxoVestibularService.getResumoFluxo();

    this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(dadosVestibular => {
      this.dadosVestibular = dadosVestibular;
      // this.cdr.detectChanges();
    });
    this.resumoFluxoSubscription = this.fluxoVestibularService.resumoFluxoMessage$.subscribe(resumoFluxo => {
      this.resumoFluxo = resumoFluxo;

      // this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.dadosVestibularSubscription) {
      this.dadosVestibularSubscription.unsubscribe();
    }
    if (this.resumoFluxoSubscription) {
      this.resumoFluxoSubscription.unsubscribe();
    }
  }

  mostrarModal(id: string): void {
    this.modalService.open(id);
  }

}
